export enum DispatcherMode {
  ONE_BY_ONE = "one-by-one",
  ALL_AT_ONCE = "all-at-once",
  PREVIOUS_CANCELED = "previous-canceled",
  DEDUPLICATED = "deduplicated",
}
